import PropTypes from "prop-types";
import React from "react";
import Header from "../../components/Header/Header";
import InfoLine from "../../components/InfoLine/InfoLine";
import "../../styles/IntranetStyles.scss";
import "./css/IntranetLayout.scss";

const isSinglePage = sessionStorage.getItem("modalSinglePage");
export const IntranetLayout = ({ body: Body }) => (
  <div className="text-center viewport-layout">
    <div className={`fixed-block z-index`}>
      {isSinglePage ? "" : <Header />}
      <InfoLine />
    </div>

    <div
      className={`container custom-content-container text-center ${
        isSinglePage ? "" : "content-wrap-body"
      }`}
    >
      <div className={`${isSinglePage ? "single-page-layout-viewport" : "page-layout-viewport"}`}>
        <Body />
      </div>
    </div>
  </div>
);

IntranetLayout.propTypes = {
  body: PropTypes.any,
};

export default IntranetLayout;



// WEBPACK FOOTER //
// ./src/layouts/IntranetLayout/IntranetLayout.js